import PropTypes from 'prop-types';

import { Heading, Modal, Text } from '@zillow/constellation-10';
import numberUtils from '../../../utils/numberUtils';

import ModalFooter from '../ModalFooter';

const HEADING_TEXT = {
  price: 'Please confirm the price',
  squareFeet: 'Please confirm the square footage',
};

const propTypes = {
  fieldName: PropTypes.string.isRequired,
  previousValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  resetFieldAndFocus: PropTypes.func,
  saveFloorplanData: PropTypes.func,
  setShowWarningConfirmationModal: PropTypes.func,
  updateField: PropTypes.func,
  updatePreviousValue: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isModularListing: PropTypes.bool,
  handleModalCloseML: PropTypes.func,
  handleModalSubmitML: PropTypes.func,
};

const defaultProps = {
  resetFieldAndFocus: () => {},
  saveFloorplanData: () => {},
  setShowWarningConfirmationModal: () => {},
  updateField: () => {},
  updatePreviousValue: () => {},
  isModularListing: false,
  handleModalCloseML: () => {},
  handleModalSubmitML: () => {},
};

const InputFieldWarningConfirmationSFModal = ({
  fieldName,
  previousValue,
  resetFieldAndFocus,
  saveFloorplanData,
  setShowWarningConfirmationModal,
  updateField,
  updatePreviousValue,
  value,
  isModularListing,
  handleModalCloseML,
  handleModalSubmitML,
}) => {
  const handleModalClose = () => {
    resetFieldAndFocus(fieldName, previousValue);
    setShowWarningConfirmationModal(false);

    updateField('', fieldName);
  };

  const handleSubmit = () => {
    saveFloorplanData(fieldName, value);
    updatePreviousValue(fieldName, value);
    setShowWarningConfirmationModal(false);
  };

  const textStyles = { minHeight: '60px', display: 'flex', alignItems: 'center' };

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && (isModularListing ? handleModalCloseML : handleModalClose)()}
      header={<Heading level={3}>{HEADING_TEXT[fieldName]}</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      footer={
        <ModalFooter
          onCancel={isModularListing ? handleModalCloseML : handleModalClose}
          onSubmit={isModularListing ? handleModalSubmitML : handleSubmit}
        />
      }
      body={
        fieldName === 'price' ? (
          <Text css={textStyles}>
            You entered&nbsp;
            <strong>{`$${numberUtils.prettyPrintNumber(value)}`}</strong>. Please confirm.
          </Text>
        ) : (
          <Text css={textStyles}>
            You entered&nbsp;
            <strong>{numberUtils.prettyPrintNumber(value)}</strong>
            &nbsp;square feet. Please confirm.
          </Text>
        )
      }
    />
  );
};

InputFieldWarningConfirmationSFModal.propTypes = propTypes;
InputFieldWarningConfirmationSFModal.defaultProps = defaultProps;

export default InputFieldWarningConfirmationSFModal;
